/** Presentation-only vocabulary. Wire values, user names and unknown codes remain verbatim. */
const LABELS: Readonly<Record<string, string>> = {
  "checks": "Checks",
  "review": "Review",
  "publication": "Publication",
  "validation": "Validation",
  "lifecycle": "Lifecycle",
  "not run": "Not run",
  "current head": "Current head",
  "not published": "Not published",
  "model_return": "Model return",
  "platform_training": "Platform training",
  "Composition": "Composition",
  "FAILED": "Failed",
  "FINISHED": "Finished",
  "KILLED": "Killed",
  "RUNNING": "Running",
  "SCHEDULED": "Scheduled",
  "abandoned": "Abandoned",
  "accept": "Accept",
  "accepted": "Accepted",
  "accepted_from": "Contributing source",
  "active": "Active",
  "added": "Added",
  "applied": "Applied",
  "approved": "Approved",
  "attempting": "Attempting",
  "attested": "Attested",
  "attested_unsealed": "Attested · unsealed",
  "available": "Available",
  "awaiting_data": "Awaiting data",
  "awaiting_inputs": "Awaiting inputs",
  "awaiting_review": "Awaiting review",
  "bindings": "Bindings",
  "block": "Block",
  "blocked": "Blocked",
  "blocking": "Blocking",
  "building": "Building",
  "cancelled": "Cancelled",
  "change_plan": "Composition plan",
  "checked": "Checked",
  "claimed": "Claimed",
  "class_changed": "Class changed",
  "classify": "Classification",
  "closed": "Closed",
  "completed": "Completed",
  "computing": "Computing",
  "conflicts": "Conflicts",
  "created": "Created",
  "dataset_version": "Dataset version",
  "declared_training_input": "Declared training input",
  "deleted": "Deleted",
  "deprecated": "Deprecated",
  "detect": "Detection",
  "done": "Done",
  "draft": "Draft",
  "draft_revision": "Draft revision",
  "error": "Error",
  "eval": "Evaluation",
  "evaluated_model": "Evaluated model",
  "evaluation_input": "Evaluation input",
  "evicted": "Evicted",
  "excluded": "Excluded",
  "executed": "Executed",
  "expired": "Expired",
  "failed": "Failed",
  "finalizing": "Finalizing",
  "forbidden": "Forbidden",
  "fork": "Fork",
  "forked_from": "Forked from",
  "forking": "Forking",
  "frozen_test": "TEST",
  "full": "Full",
  "generated": "Generated",
  "imported": "Imported",
  "importing": "Importing",
  "inconsistent": "Inconsistent",
  "info": "Info",
  "initialized_from": "Initialized from",
  "initializes_training": "Initializes training",
  "inspecting": "Inspecting",
  "lost": "Lost",
  "ls_export": "Label Studio export",
  "matches": "Matches",
  "measured": "Measured",
  "measuring": "Measuring",
  "missing": "Missing",
  "model_parent": "Model parent",
  "model_version": "Model version",
  "modified": "Modified",
  "no_recent_signal": "No recent signal",
  "none": "None",
  "noop": "No-op",
  "normalizing": "Normalizing",
  "not_configured": "Not configured",
  "not_requested": "Not requested",
  "not_run": "Not run",
  "obb": "Oriented detection",
  "open": "Open",
  "outcome_unknown": "Outcome unknown",
  "partial": "Partial",
  "passed": "Passed",
  "paused": "Paused",
  "pending": "Pending",
  "platform": "Platform",
  "platform_admin": "Platform admin",
  "pose": "Pose estimation",
  "prepared_from": "Prepared from",
  "prepared_snapshot": "Prepared snapshot",
  "present": "Present",
  "previous": "Previous",
  "produced_model": "Produced model",
  "project_admin": "Project admin",
  "proposed": "Proposed",
  "publish": "Publish",
  "published": "Published",
  "publishing": "Publishing",
  "queued": "Queued",
  "ready": "Ready",
  "receipt": "Receipt",
  "recent": "Recent",
  "reconciling": "Reconciling",
  "recorded": "Recorded",
  "register": "Register",
  "registered_model": "Registered model",
  "reject": "Reject",
  "rejected": "Rejected",
  "removed": "Removed",
  "requested": "Requested",
  "required": "Required",
  "restored_from": "Restored from",
  "result_ref": "Result reference",
  "retry_wait": "Retry wait",
  "reuse": "Reuse",
  "reviewable": "Reviewable",
  "reviewed": "Reviewed",
  "reviewing": "Reviewing",
  "rework": "Rework",
  "running": "Running",
  "sampled": "Sampled",
  "sealed": "Sealed",
  "sealing": "Sealing",
  "seeding": "Seeding",
  "segment": "Segmentation",
  "selected_from": "Selected from",
  "single_node": "Single node",
  "skipped": "Skipped",
  "staging": "Staging",
  "stale": "Stale",
  "stopped": "Stopped",
  "succeeded": "Succeeded",
  "superseded": "Superseded",
  "supersedes": "Supersedes",
  "supersedes_model": "Supersedes model",
  "synced": "Synced",
  "synchronized": "Synchronized",
  "test": "TEST",
  "train": "Training",
  "training_attempt_of": "Training attempt",
  "training_input": "Training input",
  "transferring": "Transferring",
  "unavailable": "Unavailable",
  "unchanged": "Unchanged",
  "unknown": "Unknown",
  "unpublished": "Unpublished",
  "unvalidated": "Unvalidated",
  "used_input": "Considered source",
  "validated": "Validated",
  "verified": "Verified",
  "verifying": "Verifying",
  "view_source": "View source",
  "waiting": "Waiting",
  "warn": "Warn",
  "warned": "Warned",
  "warning": "Warning",
  "warnings": "Warnings"
};

/** Use only for system-owned enums, never names, paths, classes, IDs or evidence payloads. */
export function systemLabel(value: string | null | undefined): string {
  if (value == null) return "Not recorded";
  return Object.prototype.hasOwnProperty.call(LABELS, value) ? LABELS[value] : value;
}
